// src/queries/paymentGateway.query.jsx
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { getRequest, postRequest, putRequest, patchRequest, deleteRequest } from 'utils/http'

export const PAYMENT_GATEWAY_QUERY_KEY = 'payment-gateways'

export const getPaymentGateways = async () => {
  return getRequest('payment-gateways')
}

export const useGetPaymentGateways = () => {
  return useQuery({
    queryKey: [PAYMENT_GATEWAY_QUERY_KEY],
    queryFn: getPaymentGateways,
  })
}

export const createPaymentGateway = async (data) => {
  return postRequest('payment-gateways', data)
}

export const useCreatePaymentGateway = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: createPaymentGateway,
    onSuccess: () => {
      queryClient.invalidateQueries([PAYMENT_GATEWAY_QUERY_KEY])
    },
  })
}

export const updatePaymentGateway = async ({ id, data }) => {
  return putRequest(`payment-gateways/${id}`, data)
}

export const useUpdatePaymentGateway = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: updatePaymentGateway,
    onSuccess: () => {
      queryClient.invalidateQueries([PAYMENT_GATEWAY_QUERY_KEY])
    },
  })
}

export const deletePaymentGateway = async (id) => {
  return deleteRequest(`payment-gateways/${id}`)
}

export const useDeletePaymentGateway = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: deletePaymentGateway,
    onSuccess: () => {
      queryClient.invalidateQueries([PAYMENT_GATEWAY_QUERY_KEY])
    },
  })
}

export const toggleActiveGateway = async (id) => {
  return patchRequest(`payment-gateways/${id}/toggle-active`)
}

export const useToggleActiveGateway = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: toggleActiveGateway,
    onSuccess: () => {
      queryClient.invalidateQueries([PAYMENT_GATEWAY_QUERY_KEY])
    },
  })
}

export const setDefaultGateway = async (id) => {
  return patchRequest(`payment-gateways/${id}/set-default`)
}

export const useSetDefaultGateway = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: setDefaultGateway,
    onSuccess: () => {
      queryClient.invalidateQueries([PAYMENT_GATEWAY_QUERY_KEY])
    },
  })
}

export const testGatewayConnection = async ({ id, data }) => {
  const url = id ? `payment-gateways/${id}/test` : 'payment-gateways/test'
  return postRequest(url, data || {})
}

export const useTestGatewayConnection = () => {
  return useMutation({
    mutationFn: testGatewayConnection,
  })
}
